export default {
  pageTitle: 'Manage Voucher Batches',
  region: 'Region',
  BD: 'BD',
  stateFiltering: 'State filtering',
  radio1: 'All',
  radio2: 'Pending review',
  radio3: 'Approved',
  radio4: 'Cancelled',
  radio5: 'Available',
  radio6: 'Closed',
  timeFiltering: 'Time filtering',
  createCouponBatch: ' Create coupon batch',
  //  Are you sure you want to {{ this.confirmKeyword.toLowerCase() }} it?
  main1: 'Are you sure you want to',
  main2: 'it',
  columns1: 'ID (batch)',
  columns2: 'Template ID, name',
  columns3: 'Template name',
  columns4: 'Batch Type',
  businessType: 'Business Type',
  businessTypeGeneral: 'General Voucher',
  businessTypeCps: 'CPS Voucher',
  columns5: 'Founder',
  columns6: 'Created time',
  columns7: 'Conditions',
  columns8: 'Denomination',
  columns9: 'Limit',
  columns10: 'Review Time',
  columns11: 'Reviewer',
  columns12: 'Number of issued',
  columns13: 'Number of Collected',
  columns14: 'Start time',
  columns15: 'End time',
  columns16: 'Available days afte user collected',
  columns17: 'LimitType',
  columns18: 'Limit Values',
  columns19: 'Owner Type',
  columns20: 'Status',
  columns21: '操作人',
  columns22: 'Operation',
  // -----------
  genType1: 'Voucher Center',
  genType2: '定向',
  genType5: 'Invisible',
  hide: 'Hide',
  multiValues: 'Multi-values',
  ownerType1: 'Platform',
  ownerType2: 'Store',
  status1: '待审核',
  status2: '已审核',
  status3: '已取消',
  status4: '已下架',
  buttonValue1: '取消',
  buttonValue2: 'Deactivate',
  confirmKeyword1: 'Cancel',
  confirmKeyword2: 'Set Offline',
  forStore: 'For Store'
}
